import { configureStore } from '@reduxjs/toolkit'
import rootReducers from './reducer'
import { accountApi } from 'Application/Account/services/api'
import { commonApi } from 'Services/api'
import { notificationApi } from 'Application/Notification/services/api'
// import monitorReducersEnhancer from './enhancers/monitorReducers'

const store = configureStore({
  reducer: rootReducers,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(commonApi.middleware, accountApi.middleware, notificationApi.middleware),
  // preloadedState,
  // enhancers: [monitorReducersEnhancer],
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
